import React, { useEffect } from 'react';
import { Container, InvoicePanel, PaymentPanel, InvoiceContent, PanelContent } from './style';
import Banner from '@/components/Banner';
import InvoiceDetails from '@/components/Invoice';
import { BannerType, PageLayout } from '..';
import Terms from '@/components/Terms';
import Payment from '@/components/Payment';
import { airTracker } from '@/utils/airTracker';
import { COMPONENT_NAME } from '@/pages/Main';
import Summary from '@/components/Summary';

type Props = {
  layout: PageLayout;
  bannerType: BannerType;
};
const MobileLayout = ({ layout, bannerType }: Props) => {
  useEffect(() => {
    airTracker.info('Enter MobileLayout', { component: COMPONENT_NAME, layout, bannerType });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Container>
      <InvoicePanel isOnePageLayout={layout === PageLayout.ONE_PAGE}>
        <InvoiceContent>
          <Banner bannerType={bannerType} />
          <Summary />
          <InvoiceDetails />
        </InvoiceContent>
        {layout === PageLayout.ONE_PAGE && <Terms />}
      </InvoicePanel>

      {layout === PageLayout.TWO_PAGE && (
        <PaymentPanel>
          <PanelContent>
            <Payment />
          </PanelContent>
          <Terms />
        </PaymentPanel>
      )}
    </Container>
  );
};

export default MobileLayout;
